import type { ICellRendererParams } from '@ag-grid-community/core';
import type { MenuItem } from '@ics-portal/guardian';
import type { ContextMenuSettings } from '@components/ICSGrid/ICSAgGrid';
import type { Permission } from '@pages/project/_utils/access/project-permissions';

export enum TableAction {
    CREATE = 'CREATE',
    EDIT = 'EDIT',
    DELETE = 'DELETE',
}

export interface TableMenuItem<T> extends Omit<MenuItem, 'command'> {
    onSelected?: boolean;
    handler?: (params: CellRendererParams<T>) => void;
    /** Mutating custom item is hidden unless the user has this permission. */
    permission?: Permission;
}

export interface BaseItemState {
    visible?: boolean;
    disabled?: boolean;
    tooltip?: string;
}

export interface TableActionsConfig<T> {
    entityName?: string;
    baseItems?: TableAction[];
    shouldShowBaseItem?: (
        action: TableAction,
        params: CellRendererParams<T>,
    ) => boolean | BaseItemState;
    customItems?:
        | TableMenuItem<T>[]
        | ((params: CellRendererParams<T>) => TableMenuItem<T>[]);
    shouldShowCustomItem?: (
        item: TableMenuItem<T>,
        params: CellRendererParams<T>,
    ) => boolean;
    handler?: (params: CellRendererParams<T>, action: TableAction) => void;
    settings?: ContextMenuSettings;
}

interface TableContext<T> {
    selectedRows: T[];
}

type PropertyValue = string;

export type CellRendererParams<T> = ICellRendererParams<
    T,
    PropertyValue,
    TableContext<T>
>;

export type CellRendererParamsContext<T, Y> = ICellRendererParams<
    T,
    PropertyValue,
    Y
>;

export interface SelectedRowsContext<T> {
    selectedRows: T[];
}
